// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".poNoClass[data-v-47735770] .el-input.is-disabled .el-input__inner {\n  color: red !important;\n}\n[data-v-47735770] .also-notify {\n  width: 310px;\n}\n[data-v-47735770] .also-notify .el-textarea__inner {\n    height: 230px;\n}\n", ""]);
// Exports
module.exports = exports;
